/**
 * Single source of truth for GBP currency rendering.
 * Always takes pennies (int), returns "£X.XX".
 */
export function formatGBP(pennies) {
  if (pennies == null || Number.isNaN(Number(pennies))) return "£0.00";
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(pennies) / 100);
}
